// APP
// peki://coursepackage/buy
let callbackIndex = 1
const randomString = function () {
    callbackIndex += 1
    const len = 8
    const str = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz'
    let pwd = ''
    for (let index = 0; index < len; index++) {
        pwd += str.charAt(Math.floor(Math.random() * str.length))
    }
    return pwd + callbackIndex
}

export const getAuthTicket = function (successCall, errorCall) {
    const successCallName = randomString()
    const errorCallName = randomString()
    window[successCallName] = successCall || function () {}
    window[errorCallName] = errorCall || function () {}
    const url = `peki://user/auth_ticket?success=${successCallName}&error=${errorCallName}`
    window.location.href = url
}

export const buyCoursepackage = function (packageNo, liveId) {
    const url = `peki://coursepackage/buy?packageNo=${packageNo}&liveId=${liveId}`
    window.location.href = url
}

export const setAppTitle = function (title) {
    const url = `peki://tools/title?value=${title}`
    window.location.href = url
}
